/* ============================
   DP4Y Add-ons + Gift (FINAL)
   - Foto check standaard meenemen
   - Add-ons meenemen
   - Altijd gratis gift: extra-steentjes-gratis
   - Cart attribute: "Foto check"
   ============================ */

(function () {
  'use strict';

  // ---------- helpers ----------
  function sleep(ms) { return new Promise(r => setTimeout(r, ms)); }

  async function fetchJson(url, opts) {
    const res = await fetch(url, Object.assign({ credentials: 'same-origin' }, opts || {}));
    // /cart/add.js kan 422 geven bij issues -> toch proberen json te lezen
    try { return await res.json(); } catch (e) { return null; }
  }

  async function getCart() {
    return fetchJson('/cart.js');
  }

  async function addVariant(variantId, qty) {
    return fetchJson('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ id: Number(variantId), quantity: qty || 1 })
    });
  }

  async function changeCartLine(lineKey, qty) {
    // lineKey = item.key (Booster gebruikt key)
    return fetchJson('/cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ id: lineKey, quantity: qty })
    });
  }

  async function setCartAttributeFotoCheck(enabled) {
    return fetchJson('/cart/update.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({
        attributes: {
          // Keep both keys for backwards compatibility in Liquid templates
          // Shown in the cart "Service & Zekerheden" box.
          // Keep it short; the next line in Liquid already explains production starts after approval.
          "Foto check": enabled ? "Voorbeeld binnen 3 uur via WhatsApp / e-mail." : "",
          "photo_check": enabled ? "1" : ""
        }
      })
    });
  }

  async function getFirstVariantIdByHandle(handle) {
    if (!handle) return null;
    const p = await fetchJson('/products/' + handle + '.js');
    if (!p || !p.variants || !p.variants[0]) return null;
    return Number(p.variants[0].id);
  }

  function qs(sel, scope) { return (scope || document).querySelector(sel); }
  function qsa(sel, scope) { return Array.from((scope || document).querySelectorAll(sel)); }

  // ---------- DOM refs ----------
  function getWraps() {
    return {
      photoWrap: document.getElementById('dp4y-photo-check'),
      addonsWrap: document.getElementById('dp4y-addons'),
      giftWrap: document.getElementById('dp4y-gift')
    };
  }

  function collectCheckedVariantIds(scope) {
    if (!scope) return [];
    return qsa('.dp4y-addons-cb:checked', scope)
      .map(cb => Number(cb.dataset.variantId))
      .filter(Boolean);
  }

  // ---------- core ensure ----------
  async function ensureVariantInCart(variantId) {
    if (!variantId) return;

    let cart = await getCart();
    if (!cart || !cart.items) return;

    const exists = cart.items.some(it => Number(it.id) === Number(variantId));
    if (exists) return;

    // retry: soms zit er latency op add-to-cart flow
    for (let i = 0; i < 4; i++) {
      await addVariant(variantId, 1);
      await sleep(250);
      cart = await getCart();
      if (cart && cart.items && cart.items.some(it => Number(it.id) === Number(variantId))) return;
      await sleep(250);
    }
  }

  async function removeVariantFromCartByVariantId(variantId) {
    if (!variantId) return;
    const cart = await getCart();
    if (!cart || !cart.items) return;

    const line = cart.items.find(it => Number(it.id) === Number(variantId));
    if (!line) return;

    await changeCartLine(line.key, 0);
  }

  // ---------- Foto check attribute binding ----------
  function bindFotoCheckAttribute() {
    const { photoWrap } = getWraps();
    if (!photoWrap) return;

    photoWrap.addEventListener('change', async (ev) => {
      const cb = ev.target && ev.target.classList && ev.target.classList.contains('dp4y-addons-cb') ? ev.target : null;
      if (!cb) return;
      await setCartAttributeFotoCheck(cb.checked);
    });
  }

  // ---------- Gift logic ----------
  async function ensureGiftInCartAlways() {
    const { giftWrap } = getWraps();
    if (!giftWrap) return;

    const handle = giftWrap.getAttribute('data-handle');
    const giftVariantId = await getFirstVariantIdByHandle(handle);
    if (!giftVariantId) return;

    const cart = await getCart();
    if (!cart || !cart.items) return;

    // alleen toevoegen als er "echte" items in cart staan
    // (dus cart niet leeg)
    const hasAnyItem = cart.items.length > 0;
    if (!hasAnyItem) {
      // cart leeg: gift weghalen als ie er toch in zou staan
      await removeVariantFromCartByVariantId(giftVariantId);
      return;
    }

    await ensureVariantInCart(giftVariantId);
  }

  // ---------- Booster hook ----------
  // Let op: je had eerder 'booster:cart:b*add' -> dat lijkt een typo.
  // Booster triggert meestal iets in de add-to-cart flow; we luisteren breed.
  function bindBoosterAddHook() {
    const handler = async function (e) {
      try {
        const detail = e && e.detail ? e.detail : {};
        const form = detail.form;

        // Alleen op productpagina flows (form aanwezig)
        if (!form) return;

        const { photoWrap, addonsWrap, giftWrap } = getWraps();

        // 1) extra items die aangevinkt zijn
        const photoIds = collectCheckedVariantIds(photoWrap);
        const addonIds = collectCheckedVariantIds(addonsWrap);

        // 2) gift variant
        let giftVariantId = null;
        if (giftWrap) {
          const giftHandle = giftWrap.getAttribute('data-handle');
          giftVariantId = await getFirstVariantIdByHandle(giftHandle);
        }

        // 3) Foto check attribute meteen zetten (als checkbox bestaat)
        const fotoCb = photoWrap ? qs('.dp4y-addons-cb', photoWrap) : null;
        if (fotoCb) {
          await setCartAttributeFotoCheck(!!fotoCb.checked);
        }

        // 4) Inject in Booster payload (BELANGRIJK voor “Nu kopen/PayPal” flows)
        const allExtraVariantIds = []
          .concat(photoIds)
          .concat(addonIds)
          .concat(giftVariantId ? [giftVariantId] : []);

        if (detail.json && Array.isArray(detail.json.items) && allExtraVariantIds.length) {
          // voorkom dubbel
          const existingIds = new Set(detail.json.items.map(x => Number(x.id)));
          allExtraVariantIds.forEach(id => {
            if (!existingIds.has(Number(id))) {
              detail.json.items.push({ id: Number(id), quantity: 1 });
            }
          });
        }

        // 5) Fallback: zorg na add-to-cart alsnog dat gift er zeker in zit
        // (voor het geval Booster payload niet gebruikt wordt in bepaalde flows)
        await sleep(300);
        await ensureGiftInCartAlways();

      } catch (err) {
        console.warn('[DP4Y] booster hook error', err);
      }
    };

    // We luisteren op meerdere events om “soms wel/soms niet” te voorkomen.
    document.addEventListener('booster:cart:add', handler);
    document.addEventListener('booster:cart:beforeadd', handler);
    document.addEventListener('booster:cart:before-add', handler);
    document.addEventListener('booster:cart:badd', handler); // voor oudere/afwijkende naming
  }

  // ---------- When cart updates (AJAX) also enforce gift ----------
  function bindCartUpdateHook() {
    document.addEventListener('booster:cart:update', async () => {
      try {
        await ensureGiftInCartAlways();
      } catch (e) {}
    });

    // Ook bij normale page load op cart / checkout intent:
    document.addEventListener('DOMContentLoaded', async () => {
      try {
        bindFotoCheckAttribute();
        await ensureGiftInCartAlways();
      } catch (e) {}
    });
  }

  // init
  bindBoosterAddHook();
  bindCartUpdateHook();

})();
